import { render, staticRenderFns } from "./ConfiguratorHeader.vue?vue&type=template&id=227bd847&scoped=true&lang=pug&"
import script from "./ConfiguratorHeader.vue?vue&type=script&lang=js&"
export * from "./ConfiguratorHeader.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguratorHeader.vue?vue&type=style&index=0&id=227bd847&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227bd847",
  null
  
)

export default component.exports